import {ObjectProperties} from './communicationProperties';
import {QueryableEnum, QueryableProperty} from '../queryableProperty';

export class CustomerProperties extends ObjectProperties {
    constructor() {
        super();
        this.properties = [
            new QueryableEnum('isLead', 'System.Boolean', 'Type', 'enum', false,
              {},
                [{name: 'Client', value: false, icon: 'fas fa-lg fa-user-tie', color: 'var(--ui-color-dark)'},
                    {name: 'Lead', value: true, icon: 'fas fa-lg fa-star', color: 'var(--ui-color-dark)'}]),
            new QueryableProperty('contactName', 'Contact Name', 'string', false),
            new QueryableProperty('companyName', 'Company Name', 'string', false),
            new QueryableProperty('dba1', 'DBA', 'string', false),
            new QueryableProperty('email', 'Email', 'string', false),
            new QueryableProperty('phoneNumber', 'Phone Number', 'string', false),
            new QueryableProperty('notes', 'Notes', 'string', false),
            new QueryableProperty('address1', 'Address', 'string', false),
            new QueryableProperty('ein', 'EIN', 'string', false),
            new QueryableProperty('city', 'City', 'string', false),
            new QueryableProperty('state', 'State', 'string', false),
            new QueryableProperty('county', 'County', 'string', false),
            new QueryableProperty('zip', 'Zip', 'string', false),
        ];
        this.sortingPropertyName = 'id';
        this.sortingDescending = true;
    }
}
